__turbopack_context__.v({
  "share-icon-wrapper": "styles-module__6BN-Ba__share-icon-wrapper",
  "social-link": "styles-module__6BN-Ba__social-link",
});
